export default __webpack_public_path__ + "static/media/selectionMobile.406f6c28.svg";